import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from 'services/apiFetch';
import { ISendContactMsg } from 'interfaces/notification.interface';
import { sendSupportMsg } from 'services/supportMessageEndPoint';
export const createSupportMessage = createAsyncThunk(
  'createSupportMessage',
  async (data: ISendContactMsg) => {
    try {
      const endpoint = sendSupportMsg(data);
      return await apiFetch<any>(endpoint).then((res) => res?.data || null);
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else {
        if (typeof error === 'object' && error !== null) {
          if ('message' in error) {
            message = String(error.message);
          }
        }
      }
      console.log('Create Support Message catch:', message);
      throw Error(message);
    }
  }
);
